import DisclosureFooter from '~/components/members-area/DisclosureFooter.vue';
export default {
  components: {
    DisclosureFooter
  },
  props: {
    mid: Number,
    email: String,
    address: Object,
    planPriceUsd: Number,
    continueButtonAction: Function
  },
  data() {
    return {
      observer: null,
      visible: false,
      loadFailedTimeout: undefined,
      continueTimeout: undefined
    };
  },
  head() {
    return {
      script: [{
        hid: 'enquire',
        src: 'https://app.enquirelabs.com/js/enquire-labs.js',
        callback: this.loadEnquire
      }]
    };
  },
  mounted() {
    // Enquire removes its target from the DOM if you have already answered the survey - they don't seem to provide an event or other means to detect this
    this.observer = new MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (Array.from(mutation.removedNodes).includes(this.$refs.enquire_labs_target)) {
          console.log('survey complete, continuing');
          this.visible = false;
          this.continueButtonAction();
        }
      });
    });
    this.observer.observe(this.$refs.section_content, {
      childList: true
    });
    window.addEventListener('ELQuestionDisplayed', this.setVisible);
    window.addEventListener('ELQuestionStreamComplete', this.continueAfterTimeout);
    this.loadFailedTimeout = window.setTimeout(() => {
      console.warn('enquire load failed, skipping survey');
      this.continueButtonAction();
    }, 5000);
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
    window.removeEventListener('ELQuestionDisplayed', this.setVisible);
    window.removeEventListener('ELQuestionStreamComplete', this.continueAfterTimeout);
    window.clearTimeout(this.loadFailedTimeout);
    window.clearTimeout(this.continueTimeout);
  },
  methods: {
    loadEnquire() {
      window.clearTimeout(this.loadFailedTimeout);
      this.loadFailedTimeout = undefined;
      try {
        const {
          mid,
          email,
          address,
          planPriceUsd
        } = this;
        if (!mid || !email || !address) {
          this.continueButtonAction();
          return;
        }
        const API_KEY = 'Bi5UblYEfwLOpUBxIdbaySxoTbmy917kEibx-HAbzAuzVXKWlvu_lHzzJxV8jseG';
        const TARGET_ELEMENT = this.$refs.enquire_labs_target;

        // Setup the customer object. We use the customer object to decide which questions to
        // ask and to associate responses with a customer.
        const customer = {
          email,
          id: 'member_' + mid,
          order_count: 1
        };

        // Setup the transaction object. The transaction object allows us to associate order volume
        // with responses in reporting, and is included in data exports for more granular analysis.
        const transaction = {
          country_code: 'US',
          currency_code: 'USD',
          id: 'member_' + mid,
          number: 'member_' + mid,
          locality: address && address.city,
          created_at: new Date().toISOString(),
          platform: 'sales funnel',
          source: 'website',
          postcode: address && address.zip_code,
          region: address && address.state,
          total: planPriceUsd,
          total_usd: planPriceUsd
        };
        const EL = window.EnquireLabs(API_KEY, TARGET_ELEMENT, {
          transaction,
          customer,
          config: {
            integrations: {
              ga: true,
              // Set to true to fire Google Anaylitcs events
              gtm: true,
              // Set to true to fire Google Tag Manger events
              rockerbox: true // Set to true to fire Rockerbox events
            }
          }
        });
        EL.nextQuestion();

        // To toggle degbug mode. Debug mode will remain enabled until "toggleDebug()" is called
        // again, even after page reloads.
        // EnquireLabs.toggleDebug()
      } catch (err) {
        console.warn('enquire err', err);
        this.continueButtonAction();
      }
    },
    setVisible() {
      this.visible = true;
    },
    continueAfterTimeout() {
      this.visible = false;
      this.continueTimeout = window.setTimeout(this.continueButtonAction, 3000);
    }
  }
};